import React from 'react';

import atlassian from '@agilytics/utils/atlassian';
import { GridContainer, Promo, Button, CTA, SubText } from '@agilytics/components';
import content from './content.json';
import imgPromoTaskList from './img-promo-tasklist.png';
const images = {
  imgPromoTaskList,
};

export default function Consent() {
  const getConsent = () => {
    window.location = atlassian.getConsentUrl('test');
  };

  return (
    <GridContainer>
      {content.map((promo, i) => (
        <Promo key={`promo-${i}`} {...promo} image={images[promo.image]} direction={promo.direction} imageSize="50%" />
      ))}
      <CTA>
        <Button size="xl" onClick={getConsent}>
          connect
        </Button>
        <SubText>we will never ask you for your username or password</SubText>
      </CTA>
    </GridContainer>
  );
}
